module.exports = __webpack_public_path__ + "media/images/logo-light-e315943f3bef43bff9fcca152f7497f7.png";